import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ReportStatus, ReportType } from './index';
import { PaginationProps } from '../types';

export type ReportListData = AnyObject

export type ReportListResponse = ReportListData
export type ReportListColumns = 'id' | 'name' | 'createdAt' | 'updatedAt'

export type ReportListGetParams = PaginationProps<ReportListColumns> & {
  name?: string;
  description?: string;
  status?: ReportStatus | null;
  type: ReportType | null;
  updatedAtStart?: string;
  updatedAtEnd?: string;
}

export const reportListGet = (payload: ReportListGetParams): Action<ReportListGetParams> => ({
  type: actions.reportListTrigger.toString(),
  payload,
});

export const reportListClear = (): Action => ({
  type: actions.reportListClear.toString(),
});

export const reportListErrorClear = (): Action => ({
  type: actions.reportListErrorReset.toString(),
});

export function* reportListRequestSaga({ payload }: Action<ReportListGetParams>) {
  yield put({
    type: actions.reportListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.reportListError.toString(),
      payload: {
        message: 'ReportList: Parameters not passed.',
      },
    });

    return;
  }

  const { roles, ...restParams } = payload;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/reports?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ReportListData, ReportListResponse>(
    response,
    actions.reportListSuccess.toString(),
    actions.reportListError.toString(),
    false,
    (reportListData) => reportListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.reportListTrigger.toString(),
    defaultProcessingSaga(
      reportListRequestSaga,
      {
        error: actions.reportListError.toString(),
        locationCancel: actions.reportListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.reportListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.reportListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.reportListErrorReset.toString(),
    });
  });
}
